.navbar {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  height: var(--nav-height);
  background: rgba(20, 20, 20, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--color-border-dim);
  transition: all var(--transition-base);
}

.navbar.scrolled {
  box-shadow: var(--shadow-md);
  background: rgba(20, 20, 20, 0.98);
  border-bottom-color: var(--color-border);
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 var(--container-padding);
  gap: var(--space-6);
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  text-decoration: none;
  flex-shrink: 0;
}

.logoIcon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.potatoIcon {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.4));
}

.logoText {
  display: flex;
  flex-direction: column;
  line-height: 1;
}

.logoMain {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 400;
  color: var(--color-text);
  letter-spacing: -0.02em;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.logoSub {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--color-primary);
  margin-top: -2px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

/* Desktop Nav */
.navDesktop {
  display: none;
  flex: 1;
  justify-content: center;
}

@media (min-width: 769px) {
  .navDesktop {
    display: block;
  }
}

.navList {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  list-style: none;
  padding: 0;
  margin: 0;
}

.navLink {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  height: 44px;
  padding: 0 var(--space-3);
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-dim);
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-decoration: none;
  position: relative;
}

.navLink::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.06) 0%, transparent 50%);
  border-radius: var(--radius-md);
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.navLink:hover {
  color: var(--color-text);
  background: var(--color-bg-panel);
}

.navLink:hover::before {
  opacity: 1;
}

.navLink:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.navLink.active {
  color: var(--color-text-inverse);
  background: var(--color-primary);
  box-shadow: var(--shadow-sm), var(--shadow-glow-primary);
}

.navLink.active::before {
  opacity: 1;
}

/* Nav Actions */
.navActions {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

/* Mobile Menu Button */
.mobileMenuBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: var(--color-text);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.mobileMenuBtn:hover {
  background: var(--color-bg-panel-hover);
  border-color: var(--color-border-bright);
}

.mobileMenuBtn:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

@media (min-width: 769px) {
  .mobileMenuBtn {
    display: none;
  }
}

.menuIcon {
  width: 24px;
  height: 24px;
  transition: transform var(--transition-base), opacity var(--transition-base);
}

.menuIcon.open {
  transform: rotate(90deg);
}

/* Mobile Menu */
.mobileMenu {
  position: fixed;
  top: var(--nav-height);
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--z-sticky);
  background: var(--color-bg-base);
  border-bottom: 1px solid var(--color-border);
  animation: slideDown var(--transition-base) ease-out;
  overflow-y: auto;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobileContent {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--space-6) var(--container-padding);
}

.mobileNavList {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-6);
}

.mobileNavLink {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-3);
  text-decoration: none;
  transition: all var(--transition-fast);
}

.mobileNavLink:hover {
  background: var(--color-bg-panel-hover);
  border-color: var(--color-border-bright);
  color: var(--color-primary);
}

.mobileNavLink:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.mobileNavLink.active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-text-inverse);
  box-shadow: var(--shadow-glow-primary);
}

.mobileStatus {
  padding-top: var(--space-4);
  border-top: 1px solid var(--color-border-dim);
}

.backdrop {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-sticky) - 1);
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  animation: fadeIn var(--transition-base) ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}